import {
  IIntegration,
  PlatformIntegrationEnum,
  PlatformIntegrationEvent,
} from '../types/integrationType';
import API from './';

export default class PlatformIntegrationAPI {
  static root = '/api/v1/platform-integration';

  static getEnabledEvents = async (query: string = '') => {
    const response = await API.get<IIntegration[]>(
      `${this.root}/enabled-events${query ? `?${query}` : ''}`,
    );
    return response.data;
  };

  static triggerFacebookPixelIntegrationEventAPICall = (
    creatorId: string,
    event: PlatformIntegrationEvent,
    payload: Record<string, unknown>,
    platform: PlatformIntegrationEnum,
  ) => {
    return API.post<void>(`${this.root}/${platform}/trigger`, {
      creator: creatorId,
      event,
      payload,
    });
  };
}
